import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Typography from "@mui/material/Typography";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useEffect } from "react";
import i18n from "i18next";
import { getSelectedLanguage } from "../../../store/Checkin/languageSlice";

const ManualAuthenticationModal = ({ open, onAuthenticate, onCancel,backToHomePage }) => {
  const { t } = useTranslation();
  const selectedLanguage = useSelector(getSelectedLanguage);

  useEffect(() => {
    i18n.changeLanguage(selectedLanguage);
  }, [selectedLanguage]);

  return (
    <Modal open={open} style={{ zIndex: "1" }}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: "600px",
          backgroundColor: "#f5f5f5",
          boxShadow: "0 0 24px rgba(0, 0, 0, 0.5)",
          padding: "60px",
          borderRadius: "20px",
          textAlign: "center",
        }}
      >
        <Typography sx={{ fontSize: "1.8rem", marginBottom: "20px" }}>
          <strong>{t("Manual Authentication Required")}</strong>
        </Typography>
        <Typography sx={{ fontSize: "1.1rem", marginBottom: "30px" }}>
          {t("Unable to verify your identity automatically.")}
          <br />
          {t(
            "Please proceed with manual authentication with a hotel staff member to continue."
          )}
        </Typography>
        <div className="row">
        
           <div className="col-lg-6" >
            <button
             style={{ marginTop: "20px", padding: "15px", marginLeft: "-25px", marginRight: "15px" }}
              id="btn-manualauth-authenticate"
              className="btn button-blue scan-btn"
              onClick={onAuthenticate}
            >
              {t("Authenticate")}
            </button>
            </div>

            <div className="col-lg-6" >
            <button
            style={{ marginTop: "20px", padding: "15px", marginLeft: "10px", marginRight: "3px" }}
              id="btn-manualauth-cancel"
              className="btn button-red scan-btn"
           
                onClick={() => {
                backToHomePage();
              }}
            >
              {t("Cancel")}
            </button>
            </div>
        </div>

        
       
      </Box>
    </Modal>
  );
};

export default ManualAuthenticationModal;
